import angular from 'angular';

import * as actions from '../../store/actions';

const mapStateToScope = (state) => ({
  apiDocumentationFile: state.cms.apiDocumentationFile,
  apiDocumentationToken: state.cms.apiDocumentationToken,
});

/**
 * @ngdoc function
 * @name myConsultApp.controller:developerDocumentation
 * @description
 * # developerDocumentation
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller('developerDocumentation', ($ngRedux, $rootScope, $scope, $location, $route, $http, ENV, Session) => {
    if (!$scope.isKittyhawkSuperuser && !$scope.isDeveloperUser) {
      $location.path('/');
    }
    var lastRoute = $route.current;
    $scope.$on('$locationChangeSuccess', function(event) {
      if ($route.current.$$route.controller == 'developerDocumentation') {
        $route.current = lastRoute;         
      }
    });     

    window.addEventListener("message", (event) => {
        // Always check event.origin if security matters
        if (event.data.hash || event.data.query) {
            var hashValue = event.data.hash.replace('#tag', '');
            const origin = window.location.origin
            const newUrl = '/admin/developers/api-documentation' + hashValue;
            $scope.$apply(() => {
              $location.path(newUrl);
            });
        }
    });

    $scope.requestApiDocumentationToken = () => {
      var hashString = '';
      const { uristring } = $route.current.params;
      if (uristring) {
        hashString = '#tag/' + uristring;
      }
      $scope
        .getApiDocumentationToken($http, ENV)
        .then((res) => {
          var frameUrl = ENV.apiEndpoint + '/developer/documentation/?token=' + $scope.apiDocumentationToken.token + hashString;
          $scope.$apply(() => {
            $('#myframe').attr('src', frameUrl);
          });
        })
        .catch(() => {
          const errorModalOptions = {
            heading: 'Onbe Downtime Window Error',
            message: `${id} is not available at this time.  It either does not exist or has caused an error.  Please try again later or contact support if the error persists.`,
            buttons: [
              {
                label: 'Close',
                href: '#',
                clickFn: () => {
                  $rootScope.toggleErrorModal();
                  $location.path($rootScope.routes.onbedowntimewindow, false);
                },
              },
            ],
          };
          $rootScope.toggleErrorModal(errorModalOptions);
        });
    };

    $scope.init = () => {
      $scope.requestApiDocumentationToken();
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
    };

    $scope.init();

    $scope.$on('$destroy', $scope.unsubscribe);
  });
